import { all, takeEvery, put, fork } from "redux-saga/effects";
import { push } from "react-router-redux";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

// Check Shipping Method
export function* checkAvailableShippingMethod() {
  yield takeEvery(actionTypes.MALL_CHECK_AVAILABLE_SHIPPING_METHOD, function*(
    action
  ) {
    try {
      const response = yield API.mallCheckAvailableShippingMethod(action.data);
      if (response.data.success) {
        yield put(
          actions.mallCheckAvailableShippingMethodSuccess(response.data.data)
        );
      } else {
        alert(
          "Warning: Fail to check available shipping method. \n" +
            response.data.message
        );
        yield put(actions.mallCheckAvailableShippingMethodFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(
          error,
          "Fail to check available shipping method. \n"
        )
      );
      yield put(actions.mallCheckAvailableShippingMethodFail());
    }
  });
}

// Load Order Summary
export function* loadOrderSummary() {
  yield takeEvery(actionTypes.MALL_LOAD_ORDER_SUMMARY, function*(action) {
    try {
      const response = yield API.mallLoadOrderSummary(action.data);
      if (response.data.success) {
        yield put(actions.mallLoadOrderSummarySuccess(response.data.data));
      } else {
        alert(
          "Warning: Fail to load order summary. \n" + response.data.message
        );
        yield put(actions.mallLoadOrderSummaryFail());
        yield put(
          push({
            pathname: "/cart",
            state: { type: "mall" }
          })
        );
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, " Fail to load order summary. \n")
      );
      yield put(actions.mallLoadOrderSummaryFail());
      yield put(
        push({
          pathname: "/cart",
          state: { type: "mall" }
        })
      );
    }
  });
}

// Checkout
export function* checkoutOrder() {
  yield takeEvery(actionTypes.MALL_CHECKOUT_ORDER, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallCheckoutOrder(action.data);
      if (response.data.success) {
        if (response.data.data) {
          if (
            typeof response.data.data === "string" ||
            response.data.data.find(x => x.warning) === undefined
          ) {
            yield put(
              actions.toastSuccess("You have successfully made your purchase")
            );
            yield put(push("/my-profile/?tabs=mall-order"));
            yield put(actions.mallCheckoutOrderSuccess());
            //yield put(actions.mallLoadCart());
          } else {
            alert(
              "Warning: Fail to checkout order. \n" + response.data.message
            );
            yield put(actions.mallCheckoutOrderFail("Fail"));
          }
        } else {
          alert("Warning: Fail to checkout order. \n" + response.data.message);
          yield put(actions.mallCheckoutOrderFail("Fail"));
        }
      } else {
        alert("Warning: Fail to checkout order. \n" + response.data.message);
        yield put(actions.mallCheckoutOrderFail("Fail"));
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to checkout order. \n"));
      yield put(actions.mallCheckoutOrderFail(error.response.data.message));
      yield put(actions.disableLoading());
    }
  });
}

// Order List
export function* loadOrderList() {
  yield takeEvery(actionTypes.MALL_LOAD_ORDER_LIST, function*(action) {
    try {
      const response = yield API.mallLoadOrderList(action.data);
      if (response.data.success) {
        yield put(actions.mallLoadOrderListSuccess(response.data));
      } else {
        alert("Warning: Fail to load order list. \n" + response.data.message);
        yield put(actions.mallLoadOrderListFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load order list. \n"));
      yield put(actions.mallLoadOrderListFail());
    }
  });
}

// Order Detail
export function* loadOrderDetail() {
  yield takeEvery(actionTypes.MALL_LOAD_ORDER_DETAIL, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallLoadOrderDetail(action.data);
      if (response.data.success && response.data.data) {
        if (response.data.data.length !== 0) {
          yield put(actions.mallLoadOrderDetailSuccess(response.data.data[0]));
        } else {
          alert(
            "Warning: Fail to load order detail. \n" + response.data.message
          );
          yield put(actions.mallLoadOrderDetailFail());
        }
      } else {
        alert("Warning: Fail to load order detail. \n" + response.data.message);
        yield put(actions.mallLoadOrderDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load order detail. \n"));
      yield put(actions.mallLoadOrderDetailFail());
      yield put(actions.disableLoading());
    }
  });
}

// Complete Order
export function* completeOrder() {
  yield takeEvery(actionTypes.MALL_COMPLETE_ORDER, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.mallCompleteOrder(action.data);
      if (response.data.success) {
        yield put(actions.mallCompleteOrderSuccess(response.data.message));
        yield put(actions.mallLoadOrderDetail(action.data));
      } else {
        alert("Warning: Fail to complete order. \n" + response.data.message);
        yield put(actions.mallCompleteOrderFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to complete order. \n"));
      yield put(actions.mallCompleteOrderFail());
      yield put(actions.disableLoading());
    }
  });
}

export default function* mallOrderSaga() {
  yield all([
    fork(checkAvailableShippingMethod),
    fork(loadOrderSummary),
    fork(checkoutOrder),
    fork(loadOrderList),
    fork(loadOrderDetail),
    fork(completeOrder)
  ]);
}
